export default function ContactSection() {
  return (
    <section id="contact" className="py-12 md:py-16 bg-background-100 scroll-mt-20">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-10 text-center">
          <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-xl bg-accent-50 text-accent-500 mb-5">
            <i className="ri-mail-send-line text-2xl"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-lg mx-auto">
            如果您有优质的影视资源推荐、内容合作意向或任何意见与建议，
            欢迎通过以下方式与桃子影院团队取得联系。
            我们重视每一位用户的反馈，共同打造更好的免费观影平台。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <div className="flex items-center gap-2 text-sm text-foreground-700 bg-background-100 px-4 py-2 rounded-md">
              <i className="ri-mail-line text-primary-500"></i>
              <span>contact@taozimovie.com</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-foreground-700 bg-background-100 px-4 py-2 rounded-md">
              <i className="ri-wechat-line text-primary-500"></i>
              <span>桃子影院官方</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}